import { createExternalRouteRef } from '@backstage/frontend-plugin-api';

export const viewTechDocRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
  defaultTarget: 'techdocs.docRoot',
});

export const createFromTemplateRouteRef = createExternalRouteRef({
  params: ['namespace', 'templateName'],
  defaultTarget: 'scaffolder.selectedTemplate',
});

export const techRadarRouteRef = createExternalRouteRef({
  defaultTarget: 'tech-radar.root',
});
